
// import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Useletter from '../Useletter';
import Foter from '../Foter';
import { Swiper, SwiperSlide } from "swiper/react"; // Swiper components import karein
import "swiper/css"; // Swiper ki CSS import karein
import "swiper/css/navigation"; // Navigation buttons ke liye CSS
import { Navigation, Autoplay } from "swiper/modules"; // Required modules import karein
import React, { useState, useEffect } from "react";


function Green1() {
 
        const [cart, setCart] = useState([]);
        const [cartOpen, setCartOpen] = useState(false);
       
    
        useEffect(() => {
            const savedCart = JSON.parse(localStorage.getItem("cart")) || [];
            setCart(savedCart);
        }, []);
    
        // const addToCart = () => {
        //     const imageSrc = "https://www.junaidjamshed.com/media/catalog/product/j/s/jst-25-2035_1_.jpg";
        //     const updatedCart = [...cart, imageSrc];
    
        //     setCart(updatedCart);
        //     localStorage.setItem("cart", JSON.stringify(updatedCart));
        // };
       
        const addToCart = () => {
            const itemImage = "https://www.junaidjamshed.com/media/catalog/product/j/s/jst-25-2035_1_.jpg";
            setCart([...cart, itemImage]);  
            setCartOpen(true);  // 🛍 Cart pop-up show karega
        };
    
        const removeFromCart = (index) => {
            const updatedCart = cart.filter((_, i) => i !== index);
            setCart(updatedCart);
            localStorage.setItem("cart", JSON.stringify(updatedCart));
        };
    
    const show1 = () => {
        const container = document.getElementById("container");
        if (container) {
            container.src = "https://www.junaidjamshed.com/media/catalog/product/j/s/jst-25-2035_1_.jpg?width=436&height=560&canvas=436,560&optimize=medium&bg-color=255,255,255&fit=bounds" ;
            container.style.maxWidth = "436px";
            container.style.maxHeight = "560px";
        }
    };
         const show2= () => {
            document.getElementById("container").src ="https://www.junaidjamshed.com/media/catalog/product/j/s/jst-25-2035_2_.jpg?width=436&height=560&canvas=436,560&optimize=medium&bg-color=255,255,255&fit=bounds"};
            const show3= () => {
                document.getElementById("container").src ="https://www.junaidjamshed.com/media/catalog/product/j/s/jst-25-2035_3_.jpg?width=436&height=560&canvas=436,560&optimize=medium&bg-color=255,255,255&fit=bounds" 
            };


            function click2() {
                let box2 = document.getElementById('btn2')
                if (box2.style.display==="none" || box2.style.display==="") {
                    box2.style.display= "block"
                }else{box2.style.display = "none";}
               
              }
              function click1() {
                let box1 = document.getElementById('revi')
                if (box1.style.display==="none" || box1.style.display==="") {
                    box1.style.display= "block"
                }else{box1.style.display = "none";}
               
              }
      // select all///
              const [checkbox, setcheckbox] = useState(false);

    const Select= () => {
      setcheckbox(!checkbox);
    };
   
      
            return (
    <div>

      <Container>
        <Row>
            <br /><br />
        <Col>
        <div className="image-container">
        <img id="container"  itemprop="image" src="https://www.junaidjamshed.com/media/catalog/product/j/s/jst-25-2035_1_.jpg?width=436&height=560&canvas=436,560&optimize=medium&bg-color=255,255,255&fit=bounds" style={{maxWidth:" 436px", maxHeight: "560px"}}>
        </img></div>
 <br /><br />
       <div className="gre"style={{marginRight:"10px"}}>
        <img onClick={show1}   src="https://www.junaidjamshed.com/media/catalog/product/j/s/jst-25-2035_1_.jpg?width=436&height=560&canvas=436,560&optimize=medium&bg-color=255,255,255&fit=bounds"
          height="150px" width="150px"    alt="" />
       <img onClick={show2}  src="https://www.junaidjamshed.com/media/catalog/product/j/s/jst-25-2035_2_.jpg?width=436&height=560&canvas=436,560&optimize=medium&bg-color=255,255,255&fit=bounds"
    height="150px" width="150px" alt=""/>
<img onClick={show3}  src="https://www.junaidjamshed.com/media/catalog/product/j/s/jst-25-2035_3_.jpg?width=436&height=560&canvas=436,560&optimize=medium&bg-color=255,255,255&fit=bounds"  height="150px" width="150px"  alt=""/></div>
       
       
        </Col>
        <Col style={{fontFamily:"Alata,sans serif"}}>
        <h1 class="page-title" style={{textAlign:"left"}}>
        <span style={{fontFamily:"Alata,sans serif",fontSize:"20px",}}>BLACK LAWN UNSTITCHED 3PC | JLAWN-S-23-415</span>    </h1>
        <div style={{color:"#999999",textAlign:"left"}}>
      <span style={{}}>SKU# GL193634-3PS-025-L</span> <br />
    <strong style={{fontFamily:"Alata,sans serif",fontSize:"14px",fontWeight:"1400"}}>IN STOCK</strong>
       <br />
    <span>   <a style={{color:"inherit",fontSize:"9px",fontFamily:"Alata,sans serif",letterSpacing:"2px",color:"black"}} class="action add" href="/">
   Be the first to review this product </a></span> </div>
   <br />
   <div className="pKR" style={{textAlign:"left",fontSize:"28px",display:"flex",gap:"20px"}}>
    <div className="pk1"  style={{fontFamily:"Alata,sans serif"}}> <b>PKR 45,567.00</b></div>
<div className="pk2" style={{color:"#575757",textDecoration:"line-through"}}><b>PKR 45,567.00</b></div> 
  </div>
  <hr />
<br />
<div className="cir" style={{display:"flex",gap:"10px"}}>
<div className="circle" style={{marginTop:"8px" ,height:"11px",width:"11px",backgroundColor:"rgb(62, 214, 96)",borderRadius:"100%"}}>
 </div><div >Limited Stock Alert: Get Yours Before They're Gone! </div></div>
 <br />
 <div style={{textAlign:"left"}}> <button  className="bt" style={{fontFamily:"Alata,sans serif",fontSize:"14px",width:"60%"}}><span>ADD TO BAG</span></button></div>
<br />
<div className="text" style={{textAlign:"left",gap:"10px",letterSpacing:"1px"}}>
 <strong style={{textDecoration: "underline"}}>Embroidered 3 Piece</strong>
 <p>Glitter & Neon paste printed Malmal Dupatta: 2.5 Meter <br />
 Glitter & Neon paste printed Lawn Shirt: 2.5 Meter <br />
 Lawn Trouser: 1.8 Meter </p></div>
 <div className="add" style={{textAlign:"left"}}>
 <span style={{textDecoration: "underline"}}>Add-On: </span>
 <br />
 1 Meter Embroidered</div>

 <hr />
 <div id="more" style={{textAlign:"left"}}>       
 <button  className="btn" onClick={click2}> <strong>More information</strong></button></div>

 <br />
 <div id="btn2" style={{textAlign:"left",display:"none",fontSize:"12px"}}>
        <table>
            <tbody>
                            <tr>
                    <th>Size</th>
                    <td>3 Piece</td>
                </tr>
                            <tr>
                    <th >Color</th>
                    <td >BEIGE</td>
                </tr>
                            <tr>
                    <th>Fabric</th>
                    <td>Lawn</td>
                </tr>
                            <tr>
                    <th>Product Category</th>
                    <td >Unstitched 3 Piece</td>
                </tr>
                            <tr>
                    <th >Season</th>
                    <td>Spring Summer Collection</td>
                </tr>
                            <tr>
                    <th>Disclaimer</th>
                    <td>Due to the photographic lighting &amp; different screen calibrations, the colors of the original product may slightly vary from the picture</td>
                </tr>
                        </tbody>
        </table>
    </div>
 <hr />
 <div className="striw" style={{textAlign:"left"}}>
 <strong onClick={click1} style={{cursor:"pointer",marginRight:""}}>Reviews</strong><br /><br />
 <div className="rev" id='revi' style={{display:"none"}}>
 <span style={{fontSize:"12px"}}>You'r reviewing</span><br />
 <strong style={{fontSize:"12px"}}>BEIGE LAWN UNSTITCHED 3PC | JLAWN-S-23-060</strong>
 <br /><br />
 <strong style={{fontSize:"12px"}}>Your Rating</strong>
 <br />
 <strong style={{fontSize:"12px"}}>Quality</strong>
  <br />
  <div className="f" style={{fontSize:"42px"}}>
  <i class="fa-duotone fa-solid fa-star"></i>
  <i class="fa-duotone fa-solid fa-star"></i>
  <i class="fa-duotone fa-solid fa-star"></i>
  <i class="fa-duotone fa-solid fa-star"></i>
  <i class="fa-duotone fa-solid fa-star"></i></div>

<div  style={{textAlign:"left",fontFamily:"Alata,sans serif",fontSize:"12px",marginLeft:"10px",fontWeight:"bold"}} ><label class="label" for="email"><span>Nickname</span><span style={{color:"red"}}>*</span>
       </label></div>
  <div class="control" style={{}}>
<input style={{height:"45px", width:"95%"}} type='text' ></input>
              </div>
<br />

              <div  style={{textAlign:"left",fontFamily:"Alata,sans serif",fontSize:"12px",marginLeft:"10px",fontWeight:"bold"}} ><label class="label" for="email"><span>Summary</span><span style={{color:"red"}}>*</span>
       </label></div>
  <div class="control" style={{}}>
<input style={{height:"45px", width:"95%"}} type='text' ></input>
              </div>
<br />

              <div  style={{textAlign:"left",fontFamily:"Alata,sans serif",fontSize:"12px",marginLeft:"10px",fontWeight:"bold"}} ><label class="label" for="email"><span>Nickname</span><span style={{color:"red"}}>*</span>
       </label></div>
  <div class="control" style={{}}>
<input style={{height:"45px", width:"95%"}} type='text' ></input>
              </div>
<br />

<button className='bt' style={{fontFamily:"Alata,sans serif"}}>SUBMIT REVIEW</button>



</div></div>
<hr />
        </Col>
        </Row>
      </Container>
      <br /><br />
      
      <h1 style={{fontSize:"28px"}}>RELATED PRODUCTS</h1>
      
      <div className="" style={{textAlign:"left",marginLeft:"10%"}}>
                        Check items to add to the cart or &nbsp; &nbsp;                     
              <button 
            type="button" 
            className="bt" 
            onClick={Select}>
            {checkbox ? "Unselect" : "Select All"}
        </button>
        
                    </div>
                    
                    <br /><br />
                    <Swiper
      modules={[Navigation, Autoplay]} // Modules define karein
      slidesPerView={4} // Ek dafa me 3 slides dikhein
      spaceBetween={10} // Slides ke beech ka gap
      loop={true} // Infinite loop
      autoplay={{ delay: 2000 }} // Auto-scroll har 2 second baad
      navigation // Next/Prev buttons enable karein
    >
      <SwiperSlide>
      <div className="box-con">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/s/jst-25-2035_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=640&width=640&canvas=640:640&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 25% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br />
     <div className="remote" style={{textAlign:"left",fontFamily:"Alata,sans serif",fontSize:"14px",marginLeft:"10px"}}>
              &nbsp;&nbsp;&nbsp;  <input type="checkbox" />&nbsp;&nbsp;&nbsp;
                <label htmlFor=""><span>Add to Bag</span></label>
              </div>
</div>      </SwiperSlide>
      <SwiperSlide>
      <div className="box-con">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/4/24-7026_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=640&width=640&canvas=640:640&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 25% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br />
     <div className="remote" style={{textAlign:"left",fontFamily:"Alata,sans serif",fontSize:"14px",marginLeft:"10px"}}>
              &nbsp;&nbsp;&nbsp;  <input type="checkbox" />&nbsp;&nbsp;&nbsp;
                <label htmlFor=""><span>Add to Bag</span></label>
              </div>
</div>        </SwiperSlide>
      <SwiperSlide>
      <div className="box-con">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/w/jw-24-1704_1__1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=640&width=640&canvas=640:640&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 25% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br />
     <div className="remote" style={{textAlign:"left",fontFamily:"Alata,sans serif",fontSize:"14px",marginLeft:"10px"}}>
              &nbsp;&nbsp;&nbsp;  <input type="checkbox" />&nbsp;&nbsp;&nbsp;
                <label htmlFor=""><span>Add to Bag</span></label>
              </div>
</div>        </SwiperSlide>
      <SwiperSlide>
      <div className="box-con">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/5/25-3189_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=640&width=640&canvas=640:640&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 25% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br />
     <div className="remote" style={{textAlign:"left",fontFamily:"Alata,sans serif",fontSize:"14px",marginLeft:"10px"}}>
              &nbsp;&nbsp;&nbsp;  <input type="checkbox" />&nbsp;&nbsp;&nbsp;
                <label htmlFor=""><span>Add to Bag</span></label>
              </div>
</div>        </SwiperSlide>   
        <SwiperSlide>
      <div className="box-con">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/5/25-3099_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=640&width=640&canvas=640:640&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 25% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br />
     <div className="remote" style={{textAlign:"left",fontFamily:"Alata,sans serif",fontSize:"14px",marginLeft:"10px"}}>
              &nbsp;&nbsp;&nbsp;  <input type="checkbox" />&nbsp;&nbsp;&nbsp;
                <label htmlFor=""><span>Add to Bag</span></label>
              </div>
</div>        </SwiperSlide>
   <SwiperSlide>
<div className="box-con">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/d/jds-25-1054_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=640&width=640&canvas=640:640&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 25% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br />
     <div className="remote" style={{textAlign:"left",fontFamily:"Alata,sans serif",fontSize:"14px",marginLeft:"10px"}}>
              &nbsp;&nbsp;&nbsp;  <input type="checkbox" />&nbsp;&nbsp;&nbsp;
                <label htmlFor=""><span>Add to Bag</span></label>
              </div>
</div>        </SwiperSlide>   <SwiperSlide>
<div className="box-con">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/p/jpw-24-032_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=640&width=640&canvas=640:640&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 25% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br />
     <div className="remote" style={{textAlign:"left",fontFamily:"Alata,sans serif",fontSize:"14px",marginLeft:"10px"}}>
              &nbsp;&nbsp;&nbsp;  <input type="checkbox" />&nbsp;&nbsp;&nbsp;
                <label htmlFor=""><span>Add to Bag</span></label>
              </div>
</div>        </SwiperSlide>   

    </Swiper>
    <div style={{ position: "relative", cursor: "pointer" }} onClick={() => setCartOpen(!cartOpen)}>
                <i className="fa-solid fa-cart-shopping" style={{ fontSize: "24px" }}></i>
                {cart.length > 0 && (
                    <span style={{
                        position: "absolute",
                        top: "-5px",
                        right: "-10px",
                        background: "red",
                        color: "white",
                        borderRadius: "50%",
                        padding: "5px 10px",
                        fontSize: "12px"}}>
                    
                        {cart.length}
                    </span>
                )}
            </div>

            {/* Product Box */}
            <div className="img-box">
                
                    <img 
                        src="https://www.junaidjamshed.com/media/catalog/product/j/s/jst-25-2035_1_.jpg"
                        alt="J. Printed Lawn 2PC"
                        style={{ height: "250px", width: "100%" }}
                    />
            </div>

            {/* Add to Cart Button */}
            <div style={{ textAlign: "left" }}>

              

            </div>
            <button 
    className="bt" 
    style={{ fontFamily: "Alata, sans-serif", fontSize: "14px", width: "40%", cursor: "pointer" }} onClick={addToCart}
    
>
    ADD TO BAG
</button>
            {/* Cart Popup */}
            {cartOpen && (
                <div style={{ }}>
                    <h3>Cart Items</h3>
                    <ul>
    {cart.map((item, index) => (
        <li key={index} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "5px" }}>
            <img src={item} width="40px" height="40px" alt="cart item" />
            <button onClick={() => removeFromCart(index)} style={{ background: "red", color: "white", border: "none", padding: "5px", cursor: "pointer" }}>Remove</button>
        </li>
                        ))}
                    </ul>
                </div>
            )}

        <Useletter/>
                    <Foter/>
                    
    </div>
  )
}

export default Green1
